module.exports = __webpack_public_path__ + "img/14ry_tp02.2315f919.jpg";